import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from '../../common/directives/directives.module';

@Component({
    selector: 'lib-html-view-dialog',
    imports: [CommonModule, MatDialogModule, DirectivesModule, MatButtonModule, TranslateModule],
    templateUrl: './html-view-dialog.component.html',
    styleUrls: ['./html-view-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HtmlViewDialogComponent {
  constructor(public dialogRef: MatDialogRef<HtmlViewDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: string) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
